'use client';

import React, { memo, useMemo } from 'react';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/file_000000009cc081fab02cf416e440d4e7-1788284465197.png',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt="Livora Groups"
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          imageRendering: 'crisp-edges',
          flexShrink: 0,
          filter: 'drop-shadow(0 0 6px rgba(201,168,76,0.35))',
        }}
        loading="eager"
      />
    </div>
  );
});

export default AppLogo;
